/*
 * OP Fast Checkout – funnel tracking (added 27 Oct 2026, de-duplicated 27 Oct 2026).
 * The floating COD form skips Shopify's cart/checkout, so Shopify's pixels never saw
 * "add to cart" or "checkout started" for those buyers. This file publishes them as custom
 * events; the "OP Fast Checkout" custom pixel (Settings → Customer events) sends them on to
 * Meta (AddToCart / InitiateCheckout), TikTok and Google.
 * Purchase is NOT sent from here: Shopify's Facebook & Instagram app already sends every order.
 * Does not change how the form or checkout works (listens only, never blocks a click).
 *
 * No double counting: the same buyer opening the form again for the same product/pack
 * (or the same cart) within 30 minutes is not counted again.
 * Loaded from snippets/op-head.liquid (and the product section; the guard below runs it once).
 */
(function () {
  'use strict';
  if (window.__opCodTracking) return;
  window.__opCodTracking = true;

  var WINDOW_MS = 30 * 60 * 1000;
  var KEY = 'op_trk_sent';

  function publish(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) {}
  }

  function uid(prefix) {
    return prefix + '-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  }

  /* true the first time this event+signature is seen in the last 30 minutes (this browser tab session). */
  function firstTime(name, signature) {
    var sent = {};
    try { sent = JSON.parse(sessionStorage.getItem(KEY) || '{}') || {}; } catch (e) { sent = {}; }
    var now = Date.now();
    Object.keys(sent).forEach(function (k) { if (now - sent[k] > WINDOW_MS) delete sent[k]; });
    var k = name + '|' + signature;
    if (sent[k]) return false;
    sent[k] = now;
    try { sessionStorage.setItem(KEY, JSON.stringify(sent)); } catch (e) {}
    return true;
  }

  function popupOn() {
    var d = document.querySelector('[data-opx]');
    if (d) return d.dataset.enabled === 'true';
    var tpl = document.getElementById('OpxTemplate');
    return !!(tpl && /data-enabled="true"/.test(tpl.innerHTML));
  }

  function packQty() {
    var picked = document.querySelector('[data-op-packs] input:checked');
    var qty = document.querySelector('.product-form__quantity input[name="quantity"], quantity-input input');
    var n = parseInt((picked && picked.value) || (qty && qty.value) || '1', 10);
    return n >= 1 && n <= 50 ? n : 1;
  }

  function variantId(root) {
    var input = document.querySelector('product-form form input[name="id"], form[action*="/cart/add"] input[name="id"]');
    return String((input && input.value) || root.dataset.variant || '');
  }

  document.addEventListener('click', function (e) {
    try {
      if (!e.target || !e.target.closest) return;

      /* "Order now – Cash on Delivery" on a product page: AddToCart + InitiateCheckout. */
      var btn = e.target.closest('[data-op-cod-open]');
      if (btn) {
        if (!popupOn()) return; // form off: Shopify checkout reports these itself
        var root = btn.closest('[data-op-cod]');
        if (!root) return;
        var q = packQty();
        var vid = variantId(root);
        var price = (Number(root.dataset.price) || 0) / 100;
        var data = {
          value: Math.round(price * q * 100) / 100,
          currency: 'PKR',
          items: [{
            productId: root.dataset.productId || '',
            variantId: vid,
            title: root.dataset.title || '',
            quantity: q,
            price: price,
          }],
        };
        var sig = 'buynow:' + vid + 'x' + q;
        if (firstTime('atc', sig)) publish('op_cod_add_to_cart', Object.assign({eventId: uid('opatc')}, data));
        if (firstTime('ic', sig)) publish('op_cod_checkout_started', Object.assign({eventId: uid('opic')}, data));
        return;
      }

      /* Cart "Check out" button while the form is on: InitiateCheckout (AddToCart already fired
         by Shopify when the item went into the cart). */
      if (!popupOn()) return;
      var t = e.target.closest(
        'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href^="/checkout?"], [data-op-checkout]'
      );
      if (!t) return;
      var dialog = document.querySelector('[data-opx]');
      if (dialog && dialog.contains(t)) return;
      fetch('/cart.js', {headers: {Accept: 'application/json'}})
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          if (!cart || !cart.item_count) return;
          var sig = 'cart:' + cart.items.map(function (it) { return it.variant_id + 'x' + it.quantity; }).sort().join(',');
          if (!firstTime('ic', sig)) return;
          publish('op_cod_checkout_started', {
            eventId: uid('opic'),
            value: cart.total_price / 100,
            currency: cart.currency || 'PKR',
            items: cart.items.map(function (it) {
              return {
                productId: String(it.product_id),
                variantId: String(it.variant_id),
                title: it.product_title,
                quantity: it.quantity,
                price: it.final_price / 100,
              };
            }),
          });
        })
        .catch(function () {});
    } catch (err) {}
  }, true);
})();
